"use strict";
exports.__esModule = true;
exports.Legend = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_measure_1 = tslib_1.__importDefault(require("react-measure"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var FluidLegend_1 = require("./FluidLegend");
var StaticLegend_1 = require("./StaticLegend");
var HeatmapLegend_1 = require("./HeatmapLegend");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var PopUpLegend_1 = require("./PopUpLegend/PopUpLegend");
var PositionTypes_1 = require("./PositionTypes");
var HEATMAP_LEGEND_WIDTH_BREAKPOINT = 460;
/**
 * @internal
 */
var Legend = /** @class */ (function (_super) {
    tslib_1.__extends(Legend, _super);
    function Legend() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onItemClick = function (item) {
            _this.props.onItemClick(item);
        };
        _this.getSeries = function () {
            var _a = _this.props, series = _a.series, _b = _a.legendItemsEnabled, legendItemsEnabled = _b === void 0 ? [] : _b, seriesMapper = _a.seriesMapper;
            var seriesWithVisibility = series.map(function (seriesItem) {
                var isVisible = legendItemsEnabled[seriesItem.legendIndex];
                return tslib_1.__assign(tslib_1.__assign({}, seriesItem), { isVisible: isVisible });
            });
            if (seriesMapper) {
                return seriesMapper(seriesWithVisibility);
            }
            return seriesWithVisibility;
        };
        _this.renderPopUpLegend = function () {
            var _a = _this.props, legendLabel = _a.legendLabel, maximumRows = _a.maximumRows, enableBorderRadius = _a.enableBorderRadius, _b = _a.containerId, containerId = _b === void 0 ? "" : _b;
            return (react_1["default"].createElement(PopUpLegend_1.PopUpLegend, { containerId: containerId, series: _this.getSeries(), maxRows: maximumRows, name: legendLabel, enableBorderRadius: enableBorderRadius, onLegendItemClick: _this.onItemClick }));
        };
        _this.renderFluid = function () {
            var enableBorderRadius = _this.props.enableBorderRadius;
            return (react_1["default"].createElement(react_measure_1["default"], { client: true }, function (_a) {
                var measureRef = _a.measureRef, contentRect = _a.contentRect;
                var usedWidth = contentRect.client && contentRect.client.width
                    ? Math.floor(contentRect.client.width)
                    : 0;
                return (react_1["default"].createElement("div", { className: "viz-fluid-legend-wrap", ref: measureRef },
                    react_1["default"].createElement(FluidLegend_1.FluidLegend, { series: _this.getSeries(), enableBorderRadius: enableBorderRadius, onItemClick: _this.onItemClick, containerWidth: usedWidth })));
            }));
        };
        _this.renderStatic = function () {
            var _a = _this.props, position = _a.position, height = _a.height, enableBorderRadius = _a.enableBorderRadius, responsive = _a.responsive, label = _a.legendLabel;
            var classNames = classnames_1["default"]("viz-static-legend-wrap", "position-" + position);
            var buttonOrientation = responsive === "autoPositionWithPopup" ? "leftRight" : "upDown";
            var props = {
                containerHeight: 0,
                series: _this.getSeries(),
                onItemClick: _this.onItemClick,
                position: position,
                enableBorderRadius: enableBorderRadius,
                buttonOrientation: buttonOrientation,
                label: label
            };
            return (react_1["default"].createElement(react_measure_1["default"], { client: true }, function (_a) {
                var measureRef = _a.measureRef, contentRect = _a.contentRect;
                var measuredHeight = contentRect.client && contentRect.client.height
                    ? Math.floor(contentRect.client.height)
                    : 0;
                var usedHeight = height || measuredHeight;
                if (!isEmpty_1["default"](contentRect.client)) {
                    _this.props.validateOverHeight(contentRect.client);
                }
                return (react_1["default"].createElement("div", { className: classNames, ref: measureRef },
                    react_1["default"].createElement(StaticLegend_1.StaticLegend, tslib_1.__assign({}, props, { containerHeight: usedHeight }))));
            }));
        };
        _this.renderHeatmapLegend = function (contentDimensions) {
            var _a = _this.props, locale = _a.locale, format = _a.format, responsive = _a.responsive, position = _a.position, legendLabel = _a.legendLabel;
            var showFluidLegend = _this.props.showFluidLegend;
            var series = _this.getSeries();
            var isFluidResponsive = Boolean(responsive === true && showFluidLegend);
            var isPopupResponsive = (position === PositionTypes_1.TOP || position === PositionTypes_1.BOTTOM) &&
                responsive === "autoPositionWithPopup" &&
                contentDimensions.width &&
                contentDimensions.width < HEATMAP_LEGEND_WIDTH_BREAKPOINT;
            var size = "large";
            if (isFluidResponsive) {
                size = "medium";
            }
            if (isPopupResponsive) {
                size = "small";
            }
            return (react_1["default"].createElement(sdk_ui_1.IntlWrapper, { locale: locale },
                react_1["default"].createElement(sdk_ui_1.IntlTranslationsProvider, null, function (props) { return (react_1["default"].createElement(HeatmapLegend_1.HeatmapLegend, { title: legendLabel, series: series, format: format, size: size, numericSymbols: props.numericSymbols, position: position })); })));
        };
        return _this;
    }
    Legend.prototype.render = function () {
        var _a = this.props, contentDimensions = _a.contentDimensions, responsive = _a.responsive, heatmapLegend = _a.heatmapLegend, showFluidLegend = _a.showFluidLegend, maximumRows = _a.maximumRows;
        if (heatmapLegend) {
            return this.renderHeatmapLegend(contentDimensions);
        }
        if (responsive === "autoPositionWithPopup" && maximumRows) {
            return this.renderPopUpLegend();
        }
        var isFluidLegend = responsive === true && showFluidLegend;
        if (isFluidLegend) {
            return this.renderFluid();
        }
        return this.renderStatic();
    };
    Legend.defaultProps = {
        responsive: false,
        legendItemsEnabled: [],
        height: 0,
        showFluidLegend: false,
        isLegendOverHeight: false,
        enableBorderRadius: false
    };
    return Legend;
}(react_1["default"].PureComponent));
exports.Legend = Legend;
//# sourceMappingURL=Legend.js.map